<template>
  <div class="acc-select-group">
    <div class="acc-select-label">
      {{ $t('heading.hosting.summary.hostingAccount') }}
        <v-tooltip open-delay="150" bottom transition="custom-tooltip">
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-on="on" v-bind="attrs" size="16">$help</v-icon>
          </template>
          <div>
            <p class="p-3 mb-0">
              {{ $t('tooltip.hosting.summary.hostingAccount.tooltip') }}
            </p>
          </div>
        </v-tooltip>
    </div>
    <v-select
      class="dns-zone"
      outlined
      :hide-details="true"
      :value="valueData"
      v-model="valueData"
      :items="items"
      item-text="domain"
      item-value="id"
      return-object
      :menu-props="{
        offsetY: true,
        nudgeBottom: '8px',
      }"
    >
      <template v-slot:selection="{ item }">
        <span class="selected-item">{{ item.domain }}</span>
      </template>
    </v-select>
  </div>
</template>

<script>
export default {
  name: "ActiveServerAccountSelector",
  props: {
    items: Array,
    value: Object
  },
  computed: {
    valueData: {
      get: function () {
        return this.value;
      },
      set: function (newData) {
        this.$emit("update:value", newData);
      },
    },
  },
}
</script>

<style lang="scss">
  .acc-select-group{
    min-width: 260px;
    display: flex;
    flex-direction: column;
    .acc-select{
      &-label{
        color: var(--v-gray-darken1);
        margin-right: 4px;
        margin-bottom: 4px;
        font-size: 14px;
        font-style: normal;
        svg{
          cursor: pointer;
          width: 16px;
          height: 16px;
          transition: 0.3s;
          &:hover{
            path{
              stroke: var(--v-primary-base);
            }
          }
        }
      }
    }
  }

  .selected-item {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
    display: block;
  }
</style>